import {
  apiClient
} from "./chunk-HCVPNQUB.mjs";

// src/ops/apiKeysApi.ts
import { ApiKeyService } from "@maat/api-shared";
var API_KEY_SERVICE_PATH = {
  [ApiKeyService.Ai]: "/ai",
  [ApiKeyService.Booking]: "/booking",
  [ApiKeyService.Main]: "/main",
  [ApiKeyService.Notifications]: "/notifications",
  [ApiKeyService.Payment]: "/payment"
};
var base = (service) => `${API_KEY_SERVICE_PATH[service]}/api/admin/api-keys`;
var key = (service, id) => `${base(service)}/${encodeURIComponent(id)}`;
var apiKeysApi = {
  list: async (service, params) => apiClient.get(base(service), { params }),
  /** Responds with the plaintext key — the only time it exists. */
  issue: async (service, body) => apiClient.post(base(service), body),
  /** Mints a new key id + secret on the same row; the previous key stops working. */
  rotate: async (service, id) => apiClient.post(`${key(service, id)}/rotate`),
  /** Terminal — there is no un-revoke. */
  revoke: async (service, id) => apiClient.delete(key(service, id))
};

export {
  apiKeysApi
};
